import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, catchError, Observable, throwError } from 'rxjs';

import { BaseRestApiService } from '../../../service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { User, UserToken } from '../model/user.model';
import { TrackingType } from 'src/app/model/session-tracking/tracking-type';
import { observableToBeFn } from 'rxjs/internal/testing/TestScheduler';

@Injectable()
export class AuthService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    login(username: string, password: string): Observable<any> {
        return this.post<UserToken>(EndPoints.login, false, '', {
            user_details: { user_id: username, password: password },
            stayLoggedIn: false,
            adLogin: false
        });
    }

    tokenLogin(): Observable<any> {
        return this.post<UserToken>(EndPoints.tokenLogin, false, '');
    }

    logout(): Observable<any> {
        console.log('running auth.service logout');
        return this.post<any>(EndPoints.logout, false, '', {});
    }

    timeoutCheck(): Observable<any> {
        return this.post(EndPoints.timeoutCheck, false, '', {});
    }

    forgotUsername(email: string): Observable<any> {
        return this.post<UserToken>(EndPoints.forgotUsername, false, '', { recoveryString: email, type: 'email' });
    }

    forgotPassword(email: string): Observable<any> {
        return this.post<UserToken>(EndPoints.forgotPassword, false, '', { emailAddress: email });
    }

    getForgotPassword(emailConfirmationCode: string): Observable<any> {
        return this.post<UserToken>(EndPoints.account_getForgotPassword, false, '', { emailConfirmationCode: emailConfirmationCode });
    }

    changeForgotPassword(emailConfirmationCode: string, user: User): Observable<any> {
        return this.post<UserToken>(EndPoints.account_changeForgotPassword, false, '', { emailConfirmationCode: emailConfirmationCode, user: user });
    }

    confirmNewUser(emailConfirmationCode: string): Observable<any> {
        return this.post<UserToken>(EndPoints.account_confirmNewUser, false, '', { emailConfirmationCode: emailConfirmationCode });
    }

    updateNewUser(emailConfirmationCode: string, user: User): Observable<any> {
        return this.post<UserToken>(EndPoints.account_updateNewUser, false, '', { emailConfirmationCode: emailConfirmationCode, user: user });
    }

    ping(): Observable<any> {
        return this.post<UserToken>(EndPoints.account_Ping, false, '');
    }

    //SessionTracking API
    getPreviousSessionTracking(loginDetailId: string): Observable<any> {
        return this.getSessionTracker<TrackingType>(EndPoints.apiSessionTrack, '', 'loginDetailId=' + loginDetailId);
    }

    storeSessionTracking(trackType: TrackingType): Observable<any> {
        return this.postSessionTracker<TrackingType>(EndPoints.apiSessionTrack, false, '', trackType);
    }

    storeSessionTracking2(trackType: TrackingType) {
        const query = {
            loginDetailId: trackType.loginDetailId
        };
        return this.postSessionTracker<TrackingType>(EndPoints.apiSessionTrack, false, query, trackType);
    }

    getNextId(loginDetailId: string): Observable<any> {
        return this.getSessionTracker<TrackingType>(EndPoints.apiSessionTrackNextId, '', 'loginDetailId=' + loginDetailId);
    }
}
